import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { Provider } from "react-redux";
import Login from "./components/login";
import Dashboard from "./components/Dashboard";
import Newpassword from "./components/Newpassword";
import AuthenticationProvider from "./context/AuthenticationContext";
import requireAuthentication from "./utils/RequireAuthentication";
import Accounts from "./components/Accounts/Accounts";
import PhotoShots from "./components/Shots/PhotoShots";
import AddShot from "./components/Shots/AddShot";
import ViewShot from "./components/ViewShot";
import Companies from "./components/Companies/Companies";
import AddShotsSession from "./components/Shoots/AddShotsSession";
import AddShootQuestion from "./components/Shoots/AddShootQuestion";
import ShootTabs from "./components/Shoots/ShootsTab";
import CreateShoot from "./components/Shoots/CreateShoot";
import VideoShots from "./components/Shots/VideoShots";
import ViewShootTabs from "./components/Shoots/ViewShoot/ViewShootTabs";
import ViewOnePackage from "./components/Packages/ViewOnePackage";
import ViewShotPackageSteppers from "./components/Packages/ViewShotSteppers/ViewShotShootSteppers";
import CheckShootTabs from "./components/Shoots/ConsolidateShoot/CheckShootTabs";
import AdminClientDashboard from "./components/AdminClient/Dashboard.2";
import EditShoot from "./components/Shoots/EditShoot";
import QuestionTable from "./components/Questions/QuestionTable";
import CreateQuestion from "./components/Questions/CreateQuestion";
import EditQuestion from "./components/Questions/EditQuestion";

import PackageTable from "./components/Packages/PackageTable";
import AddShotsSessionPackage from "./components/Packages/AddShotsSession";

import configureStore, { history } from "./redux/store";
import { ConnectedRouter } from "connected-react-router";
import ForgotPassword from "./components/ForgotPassword";
import AddQuestionStepper from "./components/Shoots/AddQuestionSteppers/AddQuestionStepper";
import EditShotShootSteppers from "./components/Shoots/EditShotSteppers/EditShotShootSteppers";
// import ConfirmationDialog from "./components/Dialogs/ConfirmationDialog";

const store = configureStore({});

const AddVideoShotsSession = props => <AddShotsSession type="video" {...props} />;

const AddPhotoShotsSession = props => <AddShotsSession type="photo" {...props} />;

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <AuthenticationProvider>
          <ConnectedRouter history={history}>
            <React.Fragment>
              <Switch>
                <Route path="/" component={Login} exact />
                <Route path="/forgot-password" component={ForgotPassword} exact />
                <Route path="/new-password/:id" component={Newpassword} exact />
                <Route path="/dashboard" component={requireAuthentication(Dashboard, "ADMIN")} exact />
                <Route path="/shots" render={() => <Redirect to="/shots/photo" />} exact />
                <Route path="/shots/create" component={requireAuthentication(AddShot, "ADMIN")} exact />
                <Route path="/shots/edit/:id" component={requireAuthentication(AddShot, "ADMIN")} exact />
                <Route path="/shots/preview/:id" component={requireAuthentication(ViewShot, "ADMIN")} exact />
                <Route path="/shots/photo" component={requireAuthentication(PhotoShots, "ADMIN")} exact />
                <Route path="/shots/video" component={requireAuthentication(VideoShots, "ADMIN")} exact />
                <Route path="/accounts" component={requireAuthentication(Accounts, "ADMIN")} exact />
                {/* <Route
                  path="/companies"
                  component={requireAuthentication(Companies, "ADMIN")}
                  exact
                /> */}
                <Route path="/shoots" component={requireAuthentication(ShootTabs, "ADMIN")} exact />
                <Route path="/shoots/create" component={requireAuthentication(CreateShoot, "ADMIN")} exact />
                <Route path="/shoots/edit/:client/:date" component={requireAuthentication(EditShoot, "ADMIN")} exact />
                <Route path="/shoots/view/:client/:date" component={requireAuthentication(ViewShootTabs, "ADMIN")} exact />
                <Route path="/shoots/view/:client/:date/photo" component={requireAuthentication(ViewShootTabs, "ADMIN")} exact />
                <Route path="/shoots/view/:client/:date/video" component={requireAuthentication(ViewShootTabs, "ADMIN")} exact />
                <Route path="/shoots/view/:client/:date/question" component={requireAuthentication(ViewShootTabs, "ADMIN")} exact />
                <Route path="/shoots/check/:client/:date" component={requireAuthentication(CheckShootTabs, "ADMIN")} exact />
                <Route path="/shoots/check/:client/:date/photo" component={requireAuthentication(CheckShootTabs, "ADMIN")} exact />
                <Route path="/shoots/check/:client/:date/video" component={requireAuthentication(CheckShootTabs, "ADMIN")} exact />
                <Route path="/shoots/edit/:client/:date" component={requireAuthentication(CreateShoot, "ADMIN")} exact />
                <Route path="/shoots/add/:clinic/:created_at/photo-shots" component={requireAuthentication(AddPhotoShotsSession, "ADMIN")} exact />
                <Route path="/shoots/add/:clinic/:created_at/video-shots" component={requireAuthentication(AddVideoShotsSession, "ADMIN")} exact />
                <Route path="/shoots/add/:clinic/:created_at/add-question" component={requireAuthentication(AddQuestionStepper, "ADMIN")} exact />
                <Route path="/shoots/edit/:clinic/:created_at/package/:id" component={requireAuthentication(EditShotShootSteppers, "ADMIN")} exact />
                <Route path="/category" component={requireAuthentication(ShootTabs, "ADMIN")} exact />
                <Route path="/questions" component={requireAuthentication(QuestionTable, "ADMIN")} exact />
                <Route path="/questions/add" component={requireAuthentication(CreateQuestion, "ADMIN")} exact />
                <Route path="/question/edit/:id/:type" component={requireAuthentication(EditQuestion, "ADMIN")} exact />
                <Route path="/packages" component={requireAuthentication(PackageTable, "ADMIN")} exact />
                <Route path="/packages/view/:id" component={requireAuthentication(ViewOnePackage, "ADMIN")} exact />
                <Route path="/packages/:id/shots/add" component={requireAuthentication(AddShotsSessionPackage, "ADMIN")} exact />
                <Route path="/packages/:id/shots/edit" component={requireAuthentication(ViewShotPackageSteppers, "ADMIN")} exact />

                {/* <Route path="/shoots/add-shots" component={requireAuthentication(AddShotsSession,"ADMIN")} exact /> */}
              </Switch>
            </React.Fragment>
          </ConnectedRouter>
        </AuthenticationProvider>
        {/* <ConfirmationDialog /> */}
      </Provider>
    );
  }
}

export default App;
